import { ActionHandler } from "../index";
import { queryFacialBloodScanIntroMetadata } from "src/api/facialBloodScanIntroMetadata";
import { FacialBloodScanIntroMetadata } from "gql/graphql";
import { trackEvent } from "src/utils/api/tracker";
import { setFacialBloodScanMetadata } from "src/utils/redux/slices/facialBloodScanMetadata";

let pendingMetadataPromise: Promise<FacialBloodScanIntroMetadata | null> | null =
  null;

/**
 * Initiates loading of facial blood scan intro metadata without blocking.
 * The actual GraphQL query runs asynchronously to avoid blocking page animations.
 */
export const loadFacialBloodScanIntroMetadata: ActionHandler = ({ store }) => {
  // Start the async query and store the promise for later awaiting
  pendingMetadataPromise = queryFacialBloodScanIntroMetadata()
    .then((result) => {
      if (result) {
        // Store the metadata in Redux state
        store.dispatch(setFacialBloodScanMetadata(result));

        trackEvent("OnFacialBloodScanIntroMetadataSuccess", {
          facialBloodScanCount: result.facialBloodScanCount,
          hasDateOfBirth: result.hasDateOfBirth,
          hasCompletedQuestionnaire: result.hasCompletedQuestionnaire,
          accessCode: store.getState().userData.access_code,
        });
      }

      return result;
    })
    .finally(() => {
      // Clear the promise reference after completion
      pendingMetadataPromise = null;
    });
};

/**
 * Waits for the pending metadata query to complete (if any).
 * This should be called before pages that require the metadata,
 * such as pages that need to conditionally show based on the metadata.
 */
export const waitForFacialBloodScanIntroMetadata: ActionHandler = async () => {
  if (pendingMetadataPromise) {
    await pendingMetadataPromise;
  }
};
